import React from 'react';
import OffScreenAnnouncement from '@bb-ui/react-library/dist/components/OffScreenAnnouncement/OffScreenAnnouncement';
import { Skeleton } from '@bb-ui/react-library/dist/components/Skeleton';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UserList.styles';
import { SkeletonCard } from '../../../Skeleton/SkeletonCard';
import { SkeletonTable } from '../../../Skeleton/SkeletonTable';
import { BOX_PER_ROW, InfoText } from './UserListLicenseOverview';

export const UserListLoading = (props: { columns: number; rows: number }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div data-testid="user-list-loading">
            <InfoText />

            <OffScreenAnnouncement
                type="polite"
                message={t('settings.licenseManagement.loadingAriaLabel')}
                changeTrigger={1}
            />
            <div className={classes.cardsContainer}>
                {Array.from({ length: BOX_PER_ROW }).map((_, i) => (
                    <SkeletonCard key={i} />
                ))}
            </div>
            <div className={classes.skeletonFiltersContainer}>
                <Skeleton
                    variant="text"
                    animation="wave"
                    className={classes.skeletonFilter}
                />
                <Skeleton
                    variant="text"
                    animation="wave"
                    className={classes.skeletonFilter}
                />
                <Skeleton
                    variant="text"
                    animation="wave"
                    className={classes.skeletonFilter}
                />
            </div>
            <Skeleton
                variant="text"
                animation="wave"
                width="25%"
                height="40px"
            />
            <SkeletonTable columnNum={props.columns} rowNum={props.rows} />
        </div>
    );
};
